import { render, staticRenderFns } from "./ProductPageData.vue?vue&type=template&id=d2465b96&"
import script from "./ProductPageData.vue?vue&type=script&lang=js&"
export * from "./ProductPageData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports